module.exports = "<div class=\"rw-remove-widget\">\r\n   <i class=\"fa fa-times fa-lg\"\r\n      ng-click=\"$ctrl.action()\"\r\n      aria-label=\"Remove widget\"></i>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/modules/dashboard/components/rw-remove-widget/rw-remove-widget.html
// module id = 1764
// module chunks = 0